var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecrets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "nav-icon-fill",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m19.53 5.08-6.64-2.66a2.38 2.38 0 0 0-1.78 0L4.47 5.08A2.4 2.4 0 0 0 3 7.31v2.23a12.9 12.9 0 0 0 8.16 12 2.41 2.41 0 0 0 1.78 0 12.9 12.9 0 0 0 8.16-12V7.31a2.4 2.4 0 0 0-1.57-2.23Zm0 4.46a11.43 11.43 0 0 1-7.21 10.65 1 1 0 0 1-.68 0A11.43 11.43 0 0 1 4.45 9.54V7.31A.91.91 0 0 1 5 6.47l6.64-2.66a1 1 0 0 1 .68 0L19 6.47a.91.91 0 0 1 .57.84ZM14.75 9a2.75 2.75 0 1 0-3.5 2.63V17a.76.76 0 0 0 .75.75h2a.75.75 0 0 0 0-1.5h-1.25v-1.5H14a.75.75 0 0 0 0-1.5h-1.25v-1.62a2.75 2.75 0 0 0 2-2.63Zm-4 0A1.25 1.25 0 1 1 12 10.25 1.25 1.25 0 0 1 10.75 9Z",
    fill: "#000000",
    opacity: 1,
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecrets);
export default __webpack_public_path__ + "static/media/Secrets.6ec2f2581ab4e386ff24e7388947c8fa.svg";
export { ForwardRef as ReactComponent };